import React from 'react';
import "../App.css";
import { Icon } from './Icon';

// ─── FILTER BAR ───────────────────────────────────────────────────────
// Renders a compact filter bar. Pass only the controls a module needs.
export function FilterBar({ search, setSearch, searchPlaceholder = "Search…",
                     clientId, setClientId, clients,
                     employeeId, setEmployeeId, employees,
                     from, setFrom, to, setTo, onClear, extra, hasActive }) {
  const active = hasActive ?? ((search) || (clientId) || (employeeId) || (from) || (to));
  return (
    <div className="list-toolbar list-filter-bar">
      {setSearch && (
        <div className="list-toolbar-search">
          <input className="f-input" placeholder={searchPlaceholder}
            value={search || ""} onChange={e => setSearch(e.target.value)} />
        </div>
      )}
      {setClientId && clients && (
        <select className="f-select list-toolbar-select" value={clientId || ""} onChange={e => setClientId(e.target.value)}>
          <option value="">All clients</option>
          {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      )}
      {setEmployeeId && employees && (
        <select className="f-select list-toolbar-select" value={employeeId || ""} onChange={e => setEmployeeId(e.target.value)}>
          <option value="">All employees</option>
          {employees.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        </select>
      )}
      {(setFrom || setTo) && (
        <div className="list-toolbar-dates">
          {setFrom && (
            <label className="list-toolbar-date">
              <span className="list-toolbar-date-lbl">From</span>
              <input className="f-input" type="date" value={from || ""} onChange={e => setFrom(e.target.value)} />
            </label>
          )}
          {setTo && (
            <label className="list-toolbar-date">
              <span className="list-toolbar-date-lbl">To</span>
              <input className="f-input" type="date" value={to || ""} onChange={e => setTo(e.target.value)} />
            </label>
          )}
        </div>
      )}
      {extra && <div className="list-toolbar-extra">{extra}</div>}
      {active && onClear && (
        <div className="list-toolbar-actions">
          <button type="button" className="btn btn-sm" onClick={onClear} title="Clear filters">
            <Icon name="close" size={12} /> Clear
          </button>
        </div>
      )}
    </div>
  );
}
